import './Section.css';
import { useLayout } from './context/layout/LayoutProvider';
import type { SectionSettings } from './ModularTypes/SectionSettings';
import { SectionClassBuilder } from './builders/SectionClassBuilder';

const Section = ({ children, as, ...props }: SectionSettings) => {
  const { context } = useLayout();
  const className = SectionClassBuilder.build(props, context.section || {});
  const Component = as ?? 'section';

  return <Component className={className}>{children}</Component>;
};

export default Section;
